import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Breadcrumb from "../components/Breadcrumb";
import DemoSection from "../components/DemoSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

export default function DemoPage() {
  return (
    <>
      <Navbar />

      <Hero />

      <Breadcrumb />

      <DemoSection />

      {/* <FeatureCards /> */}

      <ContactSection />
      <Footer />
    </>
  );
}